import { Spinner } from 'react-bootstrap';

export function Loading() {
  return (
    <div className="text-center mt-2">
      <Spinner animation="border" role="status" variant="primary" />
      <p className="mb-1">Loading...</p>
    </div>
  );
}
